module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.c8b6e083.ttf";